"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Conversations = _interopRequireDefault(require("./Conversations"));

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _immutable = require("immutable");

var _Placeholder = _interopRequireDefault(require("./Placeholder"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _UIAbstractFloaty = _interopRequireDefault(require("UIComponents/tooltip/UIAbstractFloaty"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var computeFloatyPosition = (0, _conversationsHelpers.getComputeFloatyPosition)(20);
var ConversationsWrapper = (0, _createReactClass.default)({
  displayName: "ConversationsWrapper",
  propTypes: {
    closeConversations: _propTypes.default.func,
    conversations: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    currentUserId: _propTypes.default.number.isRequired,
    deleteComment: _propTypes.default.func,
    deleteCommentId: _propTypes.default.number,
    deleteCommentStatus: _propTypes.default.string,
    deleteConversation: _propTypes.default.func,
    deleteConversationDone: _propTypes.default.func,
    deleteConversationId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    deleteConversationStatus: _propTypes.default.string,
    highlightBodyText: _propTypes.default.func,
    highlightSummaryText: _propTypes.default.func,
    highlightTitleText: _propTypes.default.func,
    index: _propTypes.default.string.isRequired,
    openConversations: _propTypes.default.instanceOf(_immutable.Set),
    openConversation: _propTypes.default.func,
    refetchUsers: _propTypes.default.func,
    registerListener: _propTypes.default.func,
    removeHighlightedBodyText: _propTypes.default.func,
    removeHighlightedSummaryText: _propTypes.default.func,
    removeHighlightedTitleText: _propTypes.default.func,
    saveComment: _propTypes.default.func,
    selectedBlock: _propTypes.default.string,
    selectConversationBlock: _propTypes.default.func.isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired,
    userIsAdmin: _propTypes.default.bool
  },
  contextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  renderPlaceholder: function renderPlaceholder() {
    var _this$props = this.props,
        conversations = _this$props.conversations,
        index = _this$props.index,
        selectConversationBlock = _this$props.selectConversationBlock;
    return _react.default.createElement(_Placeholder.default, {
      index: index,
      conversations: conversations,
      selectConversationBlock: selectConversationBlock
    });
  },
  renderContent: function renderContent(isSelectedBlock) {
    return _react.default.createElement("div", {
      className: "conversations-wrapper"
    }, isSelectedBlock ? _react.default.createElement(_Conversations.default, this.props) : this.renderPlaceholder());
  },
  render: function render() {
    var index = this.props.index;
    var targetNode;

    if ((0, _conversationsHelpers.correlationIdIsOnTitle)(index)) {
      targetNode = document.querySelector("#" + _constants.TITLE_ID);
    } else if ((0, _conversationsHelpers.correlationIdIsOnSummary)(index)) {
      targetNode = document.querySelector("#" + _constants.SUMMARY_ID);
    } else {
      targetNode = document.querySelector("[data-block=true][data-offset-key=\"" + index + "\"]");
    }

    if (!targetNode) {
      return null;
    }

    var selectedBlock = this.props.selectedBlock;
    var isSelectedBlock = selectedBlock === index;
    return _react.default.createElement(_UIAbstractFloaty.default, {
      key: "$" + index + "-tether",
      computePosition: computeFloatyPosition,
      content: this.renderContent(isSelectedBlock),
      target: targetNode,
      zIndex: isSelectedBlock ? 11 : 10
    }, _react.default.createElement("div", {
      id: "comment-tether-" + index
    }));
  }
});
var _default = ConversationsWrapper;
exports.default = _default;
module.exports = exports.default;